// extracted by mini-css-extract-plugin
module.exports = {"root":"BestSong_root__3J1Hk","content":"BestSong_content__2YKuP","text":"BestSong_text__psW_S","desc":"BestSong_desc__3UZKD","title":"BestSong_title__1jzzg"};